import useOutlookClient from './useOutlookClient';

type EmailClient = {
  mode: 'Read' | 'Compose';
  getSelectedMessageId: () => Maybe<string>;
  getSelectedMessageSender: () => Maybe<{ name: string; address: string }>;
  openSendMail: ({
    to,
    cc,
    bcc,
    subject,
    body,
  }: {
    to?: string[];
    cc?: string[];
    bcc?: string[];
    subject?: string;
    body?: string;
  }) => void;
  getClientInfo: () => Promise<unknown>;
  getAllEmailAddressesFromThread: () => Promise<Array<string>>;
  getSelectedMessageDetails: () => Promise<
    Maybe<{
      messageId: string;
      subject: string;
      threadEmailAddresses: Array<string>;
      fromAddress: string;
    }>
  >;
  getEmailBody: (
    format?: 'Html' | 'Text',
    options?: { hostConfig?: boolean },
  ) => Promise<string>;
  getEmlBlob: () => Promise<Blob>;
};

export default function useEmailClient(): EmailClient {
  return useOutlookClient();
}
